<template>
  <div class="">
    <div class="">
      <div class="dialog-header">
        <div class="image">
          <icon :type="'details'" />
        </div>
        <h1>Select Organisation</h1>
      </div>

      <div class="container-fluid data-container mw-1940">
        <main class="bd-main">
          <div class="row">
            <div class="col-12">
              <div class="d-none d-lg-block">
                <div class="horizontal-flex">
                  <div class="pb-2">
                    <k-button class="btn btn-secondary w-100" type="button" @click="addNewOrg()">
                      Add New Organisation
                    </k-button>
                  </div>
                  <div class="pb-2 expand text-end">
                    <k-checkbox v-if="showArchived" size="large" class="white-checkbox" @change="toggleInactive($event)">
                      <span>Show Archived</span>
                    </k-checkbox>
                  </div>
                </div>
                <k-grid 
                  class="org-list-grid overflow-visible" 
                  :data-items="filteredOrganisations"
                  :pageable="pageable"
                  :page-size="pageSize" 
                  :sortable="false"
                  :total="count"
                  :skip="skip" 
                  :take="take" 
                  :columns="columns" 
                  @pagechange="pageChangeHandler"
                  :style="{ height: 'auto' }" 
                  :resizable="true"
                >
                  <template v-slot:orgTypeTemplate="{ props }">
                    <td v-if="props.rowType !== 'groupHeader'">
                      <span>{{ props.dataItem.organisationType == 1 ? "Xero" : "Sinchii" }} Organisation</span>
                      <span v-if="props.dataItem.organisationType == 1" class="sub-text">{{ props.dataItem.xeroTenantName }}</span>
                    </td>
                  </template>
                  <template v-slot:statusTemplate="{ props }">
                    <td v-if="props.rowType !== 'groupHeader'">
                      <span>{{ getOrgStatus(props.dataItem) }}</span>
                      <span v-if="!props.dataItem.archived && !props.dataItem.isFreeAccount && (props.dataItem.isCancelled || props.dataItem.isTrial)" class="sub-text">Expires {{ formattedDate(props.dataItem.subscriptionEndDate) }}</span>
                    </td>
                  </template>
                  <template v-slot:buttonTemplate="{ props }">
                    <td v-if="props.rowType !== 'groupHeader'" class="overflow-visible">
                      <div class="horizontal-flex">
                        <k-button variant="secondary" v-if="!props.dataItem.isOwner && (!props.dataItem.isSubscribed || props.dataItem.archived)" class="btn w-100 btn-outline-primary" :disabled="true">
                          Unavailable
                        </k-button>
                        <k-button variant="secondary" v-else-if="props.dataItem.archived" class="btn btn-secondary w-100" @click="() => tryUnArchiveOrganisation(props.dataItem)">
                          Restore
                        </k-button>
                        <k-button variant="secondary" v-else-if="!props.dataItem.isSubscribed && !props.dataItem.isTrial" class="btn btn-secondary w-100" @click="() => showSubscriptionModal(props.dataItem)">
                          Subscribe
                        </k-button>
                        <k-button variant="secondary" v-else-if="!props.dataItem.isSelected" class="btn btn-outline-primary w-100" @click="async () => switchOrganisation(props.dataItem)">
                          Select
                        </k-button>
                        <k-button variant="secondary" v-else class="btn w-100 btn-outline-primary" :disabled="true">
                          Selected
                        </k-button>
  
                        <div class="ms-4" v-if="props.dataItem.isOwner">
                          <div class="dropdown">
                            <a class="cursor-pointer" id="rollbackDropdown" role="button" data-bs-toggle="dropdown" aria-expanded="false">
                            <icon type="dot-3-dark" />
                            </a>
                            <ul class="dropdown-menu dropdown-menu-end py-2" aria-labelledby="rollbackDropdown">
                              <li>
                                <a v-if="canArchive(props)" class="dropdown-item cursor-pointer" @click="tryArchiveOrganisation(props.dataItem)">Archive Organisation</a>
                                <a class="dropdown-item cursor-pointer" :class="{ 'disabled': !canDelete(props) }" @click="(canDelete(props) ? tryDeleteOrganisation(props.dataItem) : null)">
                                  {{ (canDelete(props) ? "Delete Organisation" : "Cannot delete - cancel subscription first") }}
                                </a>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </td>
                  </template>
                </k-grid>
              </div>
            </div>
          </div>
        </main>
      </div>
    </div>
    <div class="mb-4" v-if="allowClose">
      <div class="row justify-content-center pt-5">
        <div v-if="isAffiliate" class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="showSubscriptionModal()">Subscription</k-button>
        </div>
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-outline-primary w-100" type="button" @click="cancel()">Cancel</k-button>
        </div>
      </div>
    </div>
    <div class="mb-4" v-else>
      <div class="row justify-content-center pt-5">
        <div v-if="isAffiliate" class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-secondary w-100" type="button" @click="showSubscriptionModal()">Subscription</k-button>
        </div>
        <div class="col-12 col-lg-5 text-center">
          <k-button class="btn btn-lg btn-outline-primary w-100" type="button" @click="logOut()">Log Out</k-button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import store from "@/store"
import authService from '../../services/auth-service';
import { useToast } from "vue-toastification";
import BusinessService from "../../services/business-service";
import icon from "../Icon.vue";

const toast = useToast();

const columnsData = [
  { field: "businessName", title: "Name", width: "260px" },
  { field: "organisationType", title: "Type", cell: "orgTypeTemplate", width: "240px" },
  { title: "Status", cell: "statusTemplate", width: "240px" },
  { title: "", cell: "buttonTemplate", width: "250px" }
];

export default {
  components: {
    icon
  },
  props: {
    allowClose: {
      default: true,
      type: Boolean
    }
  },
  data: function () {
    return {
      columns: null,
      organisations: [],
      showInactive: false,
      skip: 0,
      take: 5,
      pageSize: 5,
      sortDirection: 'desc',
      filter: null,
      sortable: true,
      pageable: {
        buttonCount: 5,
        info: true,
        type: "numeric",
        pageSizes: true,
        previousNext: true
      },
      columns: columnsData,
      pendingArchive: null,
      pendingDelete: null,
      pendingUnarchive: null,
      archiveModalContent: {
        title: "Archive Organisation",
        description: "Are you sure you want to archive this organisation? You can unarchive this organisation at any time",
        closeBttText: "No",
        confirmBttText: "Yes"
      },
      unarchiveModalContent: {
        title: "Unarchive Organisation",
        description: "Are you sure you want to restore this organisation? Restored organisations count towards your monthly organisation usage",
        closeBttText: "No",
        confirmBttText: "Yes"
      },
      deleteModalContent: {
        title: "Delete Organisation",
        description: "Are you sure you want to delete this organisation?",
        closeBttText: "No",
        confirmBttText: "Yes"
      },
    };
  },
  computed: {
    count() {
      if (this.showInactive) {
        return this.organisations.length ?? 0;
      }
      return this.organisations.filter((o) => !o.archived).length ?? 0;
    },
    filteredOrganisations() {
      if (this.showInactive) {
        return this.organisations.slice(this.skip, this.skip + this.take);
      }
      return this.organisations.filter((o) => !o.archived).slice(this.skip, this.skip + this.take);
    },
    isAffiliate() {
      return store.getters.isAffiliate;
    },
    showArchived() {
      return this.isAffiliate && this.organisations.some((o) => o.archived);
    },
    hasSubscription() {
      return store.getters.isSubscribed;
    },
  },
  mounted() {
    this.defineColumns();
    this.getOrganisations();
  },
  methods: {
    canArchive(props) {
      return !props.dataItem.archived && props.dataItem.isOwner && this.isAffiliate;
    },
    canDelete(props) {
      return !props.dataItem.isSubscribed || props.dataItem.isCancelled || props.dataItem.isTrial || this.isAffiliate;
    },
    async getOrganisations() {
      await BusinessService.getAllLinkedBusinessDetails()
        .then((data) => {
          this.organisations = data.organisations;
        })
        .catch((err) => {
          this.showAlert("An error occured while fetching organisations");
        });
    },
    defineColumns() {
      this.columns = columnsData.map((column) => {
        return {
          field: column.field,
          title: column.title,
          format: column.format,
          minGridWidth: column.minGridWidth,
          cell: column.cell,
          width: column.width
        };
      });
    },
    pageChangeHandler(event) {
      this.skip = event.page.skip;
      this.take = event.page.take;
    },
    getOrgStatus(dataItem) {
      if (dataItem.archived) {
        return "Archived";
      }
      else if (dataItem.isFreeAccount) {
        return "Free Account";
      }
      else if (dataItem.isTrial) {
        return "Free Trial";
      }
      else if (dataItem.isSubscribed) {
        return "Subscribed"
      }
      else {
        return "Subscription Expired";
      }
    },
    toggleInactive(event) {
      this.showInactive = event.value;
    },
    showSuccess(message) {
      toast.clear();
      toast.success(message);
    },
    showAlert(alert) {
      toast.clear();
      toast.error(alert);
    },
    tryArchiveOrganisation(dataItem) {
      this.pendingArchive = dataItem;
      // unlock screen
      this.$root.hideOrgSelectModal();
      this.$root.showConfirmation({
        modalContent: this.archiveModalContent,
        type: 'delete',
        action: () => this.archiveOrganisation(),
        cancel: () => this.$root.showOrgSelectScreen()
      });
    },
    async archiveOrganisation() {    
      await BusinessService.archiveOrganisation(this.pendingArchive.businessID)
      .then(() => {
        this.showSuccess("Organisation archived");
      })
      .catch(() => {
        this.showAlert("Unable to archive organisation, something went wrong");
      });
      
      var pendingBusinessID = this.pendingArchive.businessID;
      this.pendingArchive = null;
      if (await this.refreshInternalState(pendingBusinessID == store.getters.businessID)) {
        this.$root.showOrgSelectScreen();
      }
    },
    tryUnArchiveOrganisation(dataItem) {
      this.pendingUnarchive = dataItem;
      // unlock screen
      this.$root.hideOrgSelectModal();
      this.$root.showConfirmation({
        modalContent: this.unarchiveModalContent,
        type: 'what-if',
        action: () => this.unarchiveOrganisation(),
        cancel: () => this.$root.showOrgSelectScreen()
      });
    },
    async unarchiveOrganisation() {   
      await BusinessService.unarchiveOrganisation(this.pendingUnarchive.businessID)
      .then(() => {
        this.showSuccess("Organisation restored");
      })
      .catch(() => {
        this.showAlert("Unable to restore organisation, something went wrong");
      });
      
      this.pendingUnarchive = null;
      if (await this.refreshInternalState(true)) {
        this.$root.showOrgSelectScreen();
      }
    },
    tryDeleteOrganisation(dataItem) {
      this.pendingDelete = dataItem
      // unlock screen
      this.$root.hideOrgSelectModal();
      this.$root.showConfirmation({
        modalContent: this.deleteModalContent,
        type: 'delete',
        action: () => this.deleteOrganisation(),
        cancel: () => this.$root.showOrgSelectScreen()
      });
    },
    async deleteOrganisation() {    
      await BusinessService.deleteOrganisation(this.pendingDelete.businessID)
      .then(() => {
        this.showSuccess("Organisation deleted");
      })
      .catch(() => {
        this.showAlert("Unable to delete organisation, something went wrong");
      });
      
      var pendingBusinessID = this.pendingDelete.businessID;
      this.pendingDelete = null;    
      if (await this.refreshInternalState(pendingBusinessID == store.getters.businessID)) {
        this.$root.showOrgSelectScreen();
      }
    },
    async refreshInternalState(forceRefresh = false) {
      await authService.refreshToken();
      await this.getOrganisations();

      store.commit("setIsLoading", true);

      // Handle scenario where user no longer has a valid business link
      if (forceRefresh) {
        location.reload();
        return false;
      }

      store.commit("setIsLoading", false);
      return true;
    },
    async switchOrganisation(dataItem) {    
      await authService.switchOrganisation(dataItem.businessID);
      location.reload(); // Reload the dashboard (with new business ID context)
    },
    showSubscriptionModal(dataItem) {
      this.$root.showSubscriptionModal(dataItem?.businessID, true);
    },
    cancel() {
      this.$emit("onClose");
    },
    async logOut() {
      this.$root.hideOrgSelectModal();
      await authService.logout();
      this.$router.push("/login");
    },
    addNewOrg() {
      if (this.isAffiliate && !this.hasSubscription) {
        // must has a active PaymentMethod to add new organisation
        toast.error("You must have an active subscription to add a new organisation");
        return;
      }
      this.$emit("onAddNewOrganisation");
    },
    formattedDate(dateString) {
      const date = new Date(dateString + "Z");

      const day = String(date.getDate()).padStart(2, '0');
      const month = String(date.getMonth() + 1).padStart(2, '0'); // Months are 0-based
      const year = date.getFullYear();

      return `${day}/${month}/${year}`;
    }
  }
};

</script>
